import React, { useEffect, useState } from "react";
import { auth } from "./services/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import SEO from "./modules/common/components/SEO";
import { initGA, trackPageView } from "./modules/common/utils/analytics";
import LandingPage from "./modules/common/pages/LandingPage";
import BasicInfo from "./modules/common/pages/BasicInfo";
import PrivateRoute from "./modules/common/layout/PrivateRoute";
import Question from "./modules/common/pages/Question";
import Results from "./modules/common/pages/Results";
import LoadingScreen from "./modules/common/pages/LoadingScreen";

const AppContent = () => {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <SEO />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/basic-info" element={<BasicInfo />} />
        {/* <Route
          path="/question"
          element={<PrivateRoute user={user} component={Question} />}
        /> */}
        <Route path="/question" element={<Question />} />

        <Route
          path="/results"
          element={<PrivateRoute user={user} component={Results} />}
        />
      </Routes>
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
